import {Box, Button, SvgIconTypeMap, SxProps, Theme} from '@mui/material';
import {OverridableComponent} from '@mui/material/OverridableComponent';
import React, {FC, useCallback} from 'react';

interface PropsFromParent {
  text: string;
  onClick?: (e: any) => void;
  icon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
  containerClasses?: any;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
  buttonColor?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning' | undefined;
  sx?: SxProps<Theme>;
}

type Props = PropsFromParent;

export const BasicButton: FC<Props> = React.memo(
  ({icon, onClick, text, containerClasses, disabled, type, buttonColor = 'primary', sx}) => {
    const onClickLocal = useCallback(
      (e) => {
        if(onClick){
          onClick(e)
        }
      },
      [onClick],
    );

    return (
      <Box className={containerClasses}>
        <Button
          sx={sx}
          type={type}
          disabled={disabled}
          onClick={onClickLocal}
          variant="contained"
          color={buttonColor}
          startIcon={icon && React.createElement(icon)}>
          {text}
        </Button>
      </Box>
    );
  },
);
